import { lazyLoad } from 'utils/loadable';

export const EntityMaterialDetailPage = lazyLoad(
  () => import('./index'),
  module => module.EntityMaterialDetailPage
);
